import React , { useState , useEffect } from 'react';
import SurfImageList from './SurfResultImageList'
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
//import Loading from '../modal/Loading';
import SurfResultImageSelectBar from './SurfResultImageSelectBar';


const SurfResultImage = (props) => {
    
    const [item,setItem] = useState(undefined)
    const [bookVersionListData,setBookVersionListData] = useState(undefined)
    
    useEffect (()=>{
        setBookVersionListData(undefined)
    },[item])
    
    const getImageList = async (item) => {
        props.setLoadingShow(true)
        setBookVersionListData(undefined)
        await webapi.get('book/bookversionlistdata/'+item)
            .then(response => {
                setBookVersionListData(response.data);
            })
        props.setLoadingShow(false)
    }

    const onSearchButtonClick = event =>{
        event.preventDefault();
        getImageList(item)
    }

    return (
        [
            <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}} key={'SRI1'}>
                <form>
                    <div className="divSearch">
                        <SurfResultImageSelectBar   pageData={props.pageData}
                                                    selectedBook={props.selectedBook}
                                                    selectedChapter={props.selectedChapter}
                                                    onSearchButtonClick={onSearchButtonClick}
                                                    setItem={setItem}
                                                    setLoadingShow={props.setLoadingShow}

                        />                            
                        <input className="submit_button" type="submit" value={props.pageData.length!==0 && props.pageData[0].F29901!== undefined?props.pageData[0].F29901:29901/*"جستجو"*/} onClick={onSearchButtonClick} />
                    </div>
                </form>
            </div>
            ,
            (bookVersionListData && bookVersionListData.length>0)
            ?
                <SurfImageList bookVersionListData={bookVersionListData}  key={'SRI21'}/>
            :
                <EmptyDiv  key={'SRI22'}/>
        ]
    );
}

export default SurfResultImage;